import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './returnItem.module.css';
import Icon from '../../react-components/Icon';

const ItemImage = ({ className, blindItem, src, exchange }) => {
  if (blindItem) {
    return <img src="/r2/img/blindItemImage.svg" alt="" />;
  }
  if (exchange) {
    return (
      <>
        <img
          alt=""
          src={exchange.new || '/r2/img/blindItemImage.svg'}
          role="img"
          className={s.item_image}
        />
        <div
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '30%',
            height: '30%',
          }}
        >
          <div style={{ position: 'relative' }}>
            <img
              alt=""
              src={exchange.old || '/r2/img/blindItemImage.svg'}
              className={s.item_image}
            />
            <div style={{ position: 'absolute', top: '-11px', right: '-11px' }}>
              <Icon.ExchangeArrow />
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <img
      alt=""
      src={src || '/r2/img/blindItemImage.svg'}
      className={cx(className, s.item_image)}
      role="img"
    />
  );
};

ItemImage.defaultProps = {
  className: undefined,
  blindItem: undefined,
  src: undefined,
  exchange: undefined,
};

ItemImage.propTypes = {
  className: PropTypes.string,
  blindItem: PropTypes.bool,
  src: PropTypes.string,
  exchange: PropTypes.shape({
    old: PropTypes.string.isRequired,
    new: PropTypes.string.isRequired,
  }),
};

export default ItemImage;
